<template>
  <div class="news-detail">
    <app-header :custom-i-d="courseID" :customTitle="customTitle"></app-header>
    <main>
      <div class="container-fluid header-quiz">
        {{questionIndex+1}}/{{amountQuestion}} {{ quiz.title }}
    </div>

<!--      <div v-if="quiz.notice.length > 0" class="container-fluid notice-warpper">-->
<!--        <div class="notice-section">-->
<!--          <span class="notice-intro">คำชี้แจง : </span>{{ quiz.notice }}-->
<!--        </div>-->
<!--      </div>-->

      <div v-if="quiz.asset_question != null"  class="container-fluid title-section">
        {{ quiz.asset_question.title }}
      </div>

      <div v-if="quiz.asset_question != null"  class="container-fluid ref-section">
        <iframe width="100%" height="100%" :src="quiz.asset_question.url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>

<!--      <div v-if="quiz.title != null" class="container-fluid title-section">-->
<!--        {{ quiz.title }}-->
<!--      </div>-->

      <div class="container-fluid " style="padding-top: 20px">
        <div v-for="(choice, index) in quiz.answers" v-on:click="choiceSelected(index,quiz.id,choice.id)">
              <div class="row choice middle" >
                  <div class="col-2 check-choice">

                    <img class="choice-select" v-if="selectChoiceNumber == index" src="../../assets/svg/choice.svg" alt="choice">
                    <img class="choice-select" v-if="selectChoiceNumber != index" src="../../assets/svg/choice-normal.svg" alt="choice">
                  </div>

                <div class="col-10 text-choice">
                  {{ choice.name }}
                </div>

              </div>
        </div>
      </div>
      <!--endchoice-->

      <div v-if="questionIndex > 0"  class="container-fluid ">
          <button  v-on:click="backQuiz()" type="button" class="btn btn-danger back-button"> < ย้อนกลับ </button>
      </div>

    </main>
    <app-footer></app-footer>
  </div>
</template>

<script>
  import AppHeader from '../../components/Header.component'
  import AppFooter from '../../components/Footer.component'
  import Services from '../../services'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'quiz-doing',
    components: {
      AppHeader,
      AppFooter
    },
    props: [
      'quizId',
      'courseID'
    ],
    data () {
      let data = {
        customTitle: '',
        amountQuestion: 0,
        questionIndex: 0,
        selectChoiceNumber: -1,
        currentQuestion: 0,
        currentAnswer: -1,
        quiz: {
          'id': 364,
          'question_section_id': 68,
          'asset_question_id': null,
          'parent_question_id': null,
          'number': '1',
          'title': 'ข้อใดคือความหมายของ Startup',
          'description': null,
          'answer_type_id': 1,
          'order': 1,
          'show_number': 0,
          'created_at': '2019-05-21 22:11:03',
          'updated_at': '2019-05-22 12:02:09',
          'question_set_id': 3,
          'asset_question': null,
          'answers': [
            {
              'id': 1399,
              'question_id': 364,
              'name': 'ธุรกิจเกี่ยวกับเทคโนโลยี',
              'unit': null,
              'score': '0.00',
              'is_other': 0,
              'created_at': '2019-05-21 22:11:50',
              'updated_at': '2019-05-21 22:11:50',
              'image': null,
              'question_set_id': 3
            },
            {
              'id': 1400,
              'question_id': 364,
              'name': 'ธุรกิจที่เป็นธุรกิจขนาดกลางและขนาดย่อม (SME)',
              'unit': null,
              'score': '0.00',
              'is_other': 0,
              'created_at': '2019-05-21 22:12:13',
              'updated_at': '2019-05-21 22:12:13',
              'image': null,
              'question_set_id': 3
            },
            {
              'id': 1401,
              'question_id': 364,
              'name': 'การแสวงหาวีธีการทำธุรกิจที่ทำซ้ำได้และเติบโตได้อย่างรวดเร็วแบบก้าวกระโดด',
              'unit': null,
              'score': '1.00',
              'is_other': 0,
              'created_at': '2019-05-21 22:12:35',
              'updated_at': '2019-05-21 22:12:35',
              'image': null,
              'question_set_id': 3
            },
            {
              'id': 1402,
              'question_id': 364,
              'name': 'การแสวงหาวีธีการทำธุรกิจที่มีเป้าหมายการดำเนินการธุรกิจให้มีรายได้เติบโตอยู่ที่ประมาณปีละ 30%-50%',
              'unit': null,
              'score': '0.00',
              'is_other': 0,
              'created_at': '2019-05-21 22:13:34',
              'updated_at': '2019-05-21 22:13:44',
              'image': null,
              'question_set_id': 3
            }
          ],
          'all_child_questions': []
        },
        answersList: {'question_set_id': 2,
          'data':
          [{
            'question_id': 279,
            'answer_id': 1063,
            'answer_value': '',
            'answer_other_value': null
          },
          {'question_id': 280,
            'answer_id': 1067,
            'answer_value': '',
            'answer_other_value': null
          }
          ]
        }
      }
      return data
    },
    beforeMount () {
      this.loadQuestionSet()
    },
    computed: {
      ...mapGetters({token: 'User/getToken', questionsSet: 'Question/getQuestionSet'})
    },
    methods: {
      ...mapActions({setQuestionSet: 'Question/setQuestionSet'}),
      loadQuestionSet () {
        var self = this
        this.questionIndex = 0
        Services.question.getQuestionsBySetId(this.quizId, this.token).then(function (response) {
          self.setQuestionSet(response.questions[0])
          self.quiz = self.questionsSet.questions[0]
          self.amountQuestion = self.questionsSet.questions.length
          self.customTitle = self.questionsSet.question_set.set_name
          console.log(self.customTitle)
          console.log(self.setQuestionSet.questions)
          self.generateAnswer()
        })
      },
      choiceSelected: function (index, quizID, answerId) {
        if (this.currentQuestion !== quizID) {
          this.currentQuestion = quizID
          this.selectChoiceNumber = index

          this.answersList.data.forEach(function (answersData) {
            if (answersData.question_id === quizID) {
              answersData.answer_id = answerId
            }
          })
          // check is last question
          if (this.questionIndex + 1 < this.questionsSet.questions.length) {
            this.questionIndex++
            var self = this
            setTimeout(function () {
              self.quiz = self.questionsSet.questions[self.questionIndex]
              self.selectChoiceNumber = -1
              self.fillSelectedChoice()
            }, 500)
          } else {
            // Summit answer
            this.summitAnswer()
          }
        }
      },
      summitAnswer: function () {
        var self = this
        Services.question.saveAnswers(this.quizId, this.answersList, this.token).then(function (response) {
          console.log(response.result)
          var max = response.result.maxScore
          var score = response.result.displayScore
          self.$router.push(`/quizdone/${score}/${max}/${self.customTitle}`)
        })
      },
      backQuiz: function () {
        this.questionIndex--

        if (this.questionIndex >= 0) {
          this.quiz = this.questionsSet.questions[this.questionIndex]
          this.selectChoiceNumber = -1
          this.currentQuestion = 0
          this.fillSelectedChoice()

          console.log(this.quiz)
        }
      },
      fillSelectedChoice: function () {
        // Fill selected choice
        let self = this
        this.answersList.data.forEach(function (answersData) {
          if (answersData.question_id === self.quiz.id) {
            let index = 0
            let _self = self
            self.quiz.answers.forEach(function (answer) {
              if (answer.id === answersData.answer_id) {
                _self.selectChoiceNumber = index
              }
              index++
            })
          }
        })
      },
      generateAnswer: function () {
        this.quizId = this.questionsSet.question_set_id
        var questionsList = this.questionsSet.questions
        var genAnswer = {
          'question_set_id': this.quizId,
          'data': []
        }
        questionsList.forEach(function (question) {
          var answerOne = {
            'question_id': question.id,
            'answer_id': '',
            'answer_value': '',
            'answer_other_value': null
          }
          genAnswer.data.push(answerOne)
        })
        this.answersList = genAnswer
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/styles";

  main {
    padding-top: 45px;

    .header-quiz{
      background: #2A314E;
      color: #ffffff;
      padding-top: 10px;

      font-family: Kanit;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 30px;
      min-height: 70px;

      z-index: 1;
    }


    .notice-warpper{

      overflow: hidden;
      padding-bottom: 10px;
    }

    .notice-intro{
      color: #FA4238;
    }

    .notice-section{

      margin-top: -10px;
      padding: 15px 10px 10px 10px;

      width: 100%;
      margin-left: auto;
      margin-right: auto;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      border-radius: 10px;

      font-family: Kanit;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 21px;
      text-align: justify;
    }

    .ref-section{
      width: 100vw;
      height: 56vw;
    }


    .title-section{

      padding-top: 10px;
      font-family: Kanit;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 30px;
      min-height: 70px;
    }



    .choice{
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      min-height: 80px;

      background: #FFFFFF;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      margin-bottom: 10px;
      transition: all .4s ease;
    }
    .choice:active  { background: gray; }



    .check-choice{
      margin-top:auto;
      margin-bottom:auto;
      cursor:pointer;
      width: 90px;
    }

    .text-choice{

      /*width: 100%;*/
      margin-top:auto;
      margin-bottom:auto;

      font-family: Kanit;
      font-style: normal;
      font-weight: 300;
      font-size: 18px;
      line-height: 27px;

      color: #333333;
    }

    .back-button{

      width: 170px;
      height: 40px;

      background: #FA4238;
      border-radius: 30px;

      font-family: Kanit;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;/* identical to box height */
      text-align: center;

      color: #FFFFFF;

    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/quiz/QuizSection.page.vue